import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  DeleteProduct,
  GetAllProduct,
  SearchForProductsByTitle,
} from '../../../redux/admin/product/product_services_syn';
import {
  updateProductDetails,
  updateProductId,
  updateProductSkip,
  updateProductSortBy,
} from '../../../redux/admin/product/product_slices';
import {
  SingleTableLoader,
  TableLoader,
} from '../../../component/loader/Table_Loader';
import CurrencyFormatter from '../../../component/CurrencyFormatter';
import moment from 'moment';
import PaginationComponent from '../../../component/pagination/PaginationComponent';
import EmptyComponent from '../../../component/EmptyComponent';
import { useDebouncedCallback } from 'use-debounce';

const Product = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const {
    productSkip,
    productLimit,
    completeProduct,
    completeProductSearch,
    product_loader,
    editProductId,
    product_sort_by,
  } = useSelector((state) => state.product);

  const [sorting, setSorting] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [searchProduct, setSearchProduct] = useState('');

  useEffect(() => {
    dispatch(
      GetAllProduct({
        page: productSkip,
        limit: productLimit,
        sortBy: product_sort_by,
      })
    );

    return () => {
      dispatch(updateProductSkip(0));

      // dispatch(updateProductLimit(10));
      updateProductSortBy('date');
    };
  }, []);

  const handleDeleteClick = (item) => {
    console.log('Delete clicked:', item);
    setSelectedItem(item);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    if (selectedItem) {
      dispatch(updateProductId(selectedItem?._id));
      dispatch(
        DeleteProduct({
          ...selectedItem,
          id: selectedItem?._id,
        })
      );
      setShowDeleteModal(false);
      setSelectedItem(null);
    }
  };

  const handlePageChange = (page) => {
    dispatch(
      GetAllProduct({
        page: page,
        limit: productLimit,
      })
    );
  };

  const debounced = useDebouncedCallback(
    async (value) => {
      if (value) {
        dispatch(
          SearchForProductsByTitle({
            title: value,
            page: 0,
            limit: productLimit,
          })
        );
      }
    },
    // delay in ms
    1000
  );

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchProduct(value);

    if (value) {
      debounced(value);
    }
  };

  const handleProductSorting = (data) => {
    updateProductSortBy(data);

    dispatch(
      GetAllProduct({
        page: productSkip,
        limit: productLimit,
        sortBy: data,
      })
    );

    setSorting(false);
  };

  return (
    <>
      <div class="card max-w-[500px]">
        <div class="card-header">
          <form class="chat-search pb-0">
            <div class="chat-search-box">
              <input
                value={searchProduct || ''}
                class="form-control"
                type="text"
                name="search"
                placeholder="Search ..."
                onChange={handleInputChange}
              />

              <button type="submit" class="btn btn-sm btn-link search-icon p-0">
                <i class="bx bx-search-alt"></i>
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center gap-1">
              <h4 class="card-title flex-grow-1">All Product List</h4>

              <div class="flex sm:flex-row flex-col gap-4">
                <NavLink to="/admin_dashboard/create_product">
                  <a class="btn btn-sm btn-primary">Add Product</a>
                </NavLink>

                <div class="dropdown relative">
                  <a
                    class="dropdown-toggle btn btn-sm btn-outline-light"
                    onClick={() => setSorting(!sorting)}
                  >
                    sorting
                  </a>

                  {sorting && (
                    <div class="dropdown-menu-end absolute w-full bg-white px-2 rounded-sm flex flex-col gap-1">
                      <a
                        onClick={() => handleProductSorting('date')}
                        class="dropdown-item"
                      >
                        date
                      </a>

                      <a
                        onClick={() => handleProductSorting('product_name_asc')}
                        class="dropdown-item"
                      >
                        A-Z
                      </a>

                      <a
                        onClick={() =>
                          handleProductSorting('product_name_desc')
                        }
                        class="dropdown-item"
                      >
                        Z-A
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div>
              {product_loader ? (
                <TableLoader
                  headerArray={[
                    'Product Name',
                    'Price',
                    'Stock',
                    'Category',
                    'Date',
                    'Action',
                  ]}
                  itemArray={[1, 2, 3, 4, 5, 6]}
                />
              ) : (
                <div class="table-responsive">
                  <table class="table align-middle mb-0 table-hover table-centered">
                    <thead class="bg-light-subtle">
                      <tr>
                        <th style={{ width: '20px' }}>
                          <div class="form-check ms-1">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="customCheck1"
                            />
                            <label
                              class="form-check-label"
                              for="customCheck1"
                            ></label>
                          </div>
                        </th>
                        <th>Product Name & tag</th>
                        <th>Price</th>
                        <th>Stock</th>
                        <th>Category</th>
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {searchProduct ? (
                        completeProductSearch?.docs?.length <= 0 ? (
                          <EmptyComponent />
                        ) : (
                          completeProductSearch?.docs?.map((item, key) => (
                            <>
                              {item?._id !== editProductId ? (
                                <tr key={key}>
                                  <td>
                                    <div class="form-check ms-1">
                                      <input
                                        type="checkbox"
                                        class="form-check-input"
                                        id="customCheck2"
                                      />
                                      <label
                                        class="form-check-label"
                                        for="customCheck2"
                                      >
                                        &nbsp;
                                      </label>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="d-flex align-items-center gap-2">
                                      <div class="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                        <img
                                          src={item?.gallery[0]?.pic_url}
                                          alt=""
                                          class="avatar-md"
                                        />
                                      </div>
                                      <div>
                                        <a
                                          href="#!"
                                          class="text-dark fw-medium fs-15"
                                        >
                                          {item?.product_name}
                                        </a>
                                        <p class="text-muted mb-0 mt-1 fs-13">
                                          {item?.tags}
                                        </p>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <CurrencyFormatter
                                      value={item?.price}
                                      currency={item?.symbol}
                                    />
                                  </td>
                                  <td>
                                    <p class="mb-1 text-muted">
                                      {item?.quantity}
                                    </p>
                                  </td>
                                  <td>{item?.category}</td>
                                  <td>
                                    {`${moment(item?.date).format(
                                      'dd MM YYYY'
                                    )}`}
                                  </td>
                                  <td>
                                    <div class="d-flex gap-2">
                                      <a
                                        onClick={() => {
                                          navigate(
                                            `/admin_dashboard/view_product/${item?.product_name}@${item?._id}`
                                          );
                                        }}
                                        class="btn btn-light btn-sm"
                                      >
                                        <iconify-icon
                                          icon="solar:eye-broken"
                                          class="align-middle fs-18"
                                        ></iconify-icon>
                                      </a>

                                      <a
                                        onClick={() => {
                                          dispatch(updateProductDetails(item));

                                          navigate(
                                            '/admin_dashboard/edit_product'
                                          );
                                        }}
                                        class="btn btn-soft-primary btn-sm"
                                      >
                                        <iconify-icon
                                          icon="solar:pen-2-broken"
                                          class="align-middle fs-18"
                                        ></iconify-icon>
                                      </a>

                                      <a
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleDeleteClick(item);
                                        }}
                                        className="btn btn-soft-danger btn-sm"
                                      >
                                        <iconify-icon
                                          icon="solar:trash-bin-minimalistic-2-broken"
                                          class="align-middle fs-18"
                                        ></iconify-icon>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                              ) : (
                                <SingleTableLoader
                                  itemArray={[1, 2, 3, 4, 5, 6]}
                                />
                              )}
                            </>
                          ))
                        )
                      ) : completeProduct?.docs?.length <= 0 ? (
                        <EmptyComponent />
                      ) : (
                        completeProduct?.docs?.map((item, key) => (
                          <>
                            {item?._id !== editProductId ? (
                              <tr key={key}>
                                <td>
                                  <div class="form-check ms-1">
                                    <input
                                      type="checkbox"
                                      class="form-check-input"
                                      id="customCheck2"
                                    />
                                    <label
                                      class="form-check-label"
                                      for="customCheck2"
                                    >
                                      &nbsp;
                                    </label>
                                  </div>
                                </td>
                                <td>
                                  <div class="d-flex align-items-center gap-2">
                                    <div class="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                      <img
                                        src={item?.gallery[0]?.pic_url}
                                        alt=""
                                        class="avatar-md"
                                      />
                                    </div>
                                    <div>
                                      <a
                                        href="#!"
                                        class="text-dark fw-medium fs-15"
                                      >
                                        {item?.product_name}
                                      </a>
                                      <p class="text-muted mb-0 mt-1 fs-13">
                                        {item?.tags}
                                      </p>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <CurrencyFormatter
                                    value={item?.price}
                                    currency={item?.symbol}
                                  />
                                </td>
                                <td>
                                  <p class="mb-1 text-muted">
                                    {item?.quantity}
                                  </p>
                                </td>
                                <td>{item?.category}</td>
                                <td>
                                  {`${moment(item?.date).format('dd MM YYYY')}`}
                                </td>
                                <td>
                                  <div class="d-flex gap-2">
                                    <a
                                      onClick={() => {
                                        navigate(
                                          `/admin_dashboard/view_product/${item?.product_name}@${item?._id}`
                                        );
                                      }}
                                      class="btn btn-light btn-sm"
                                    >
                                      <iconify-icon
                                        icon="solar:eye-broken"
                                        class="align-middle fs-18"
                                      ></iconify-icon>
                                    </a>

                                    <a
                                      onClick={() => {
                                        dispatch(updateProductDetails(item));

                                        navigate(
                                          '/admin_dashboard/edit_product'
                                        );
                                      }}
                                      class="btn btn-soft-primary btn-sm"
                                    >
                                      <iconify-icon
                                        icon="solar:pen-2-broken"
                                        class="align-middle fs-18"
                                      ></iconify-icon>
                                    </a>

                                    <a
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleDeleteClick(item);
                                      }}
                                      className="btn btn-soft-danger btn-sm"
                                    >
                                      <iconify-icon
                                        icon="solar:trash-bin-minimalistic-2-broken"
                                        class="align-middle fs-18"
                                      ></iconify-icon>
                                    </a>
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              <SingleTableLoader
                                itemArray={[1, 2, 3, 4, 5, 6]}
                              />
                            )}
                          </>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div class="card-footer border-top">
              <nav aria-label="Page navigation example">
                <PaginationComponent
                  currentPage={completeProduct?.page}
                  totalItems={completeProduct?.totalDocs}
                  pageSize={productLimit}
                  handlePageChange={handlePageChange}
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
      {showDeleteModal && (
        <div
          className="modal-overlay"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <div
            className="modal-container"
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              width: '400px',
            }}
          >
            <div className="modal-header">
              <h5>Delete Product</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowDeleteModal(false)}
              />
            </div>
            <div className="modal-body" style={{ padding: '20px 0' }}>
              <p>
                Are you sure you want to <b>delete the product</b>?
              </p>
            </div>
            <div
              className="modal-footer"
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
              }}
            >
              <button
                className="btn bg-gray-300"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button className="btn btn-danger" onClick={handleConfirmDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Product;
